import { fetchPost } from 'Services/fetchService.js';

export default function deleteFavorite(taskId) {
    const response = fetchPost('/ajax/task_favorite.php', { id_task: taskId, value: 0 });
    return response;
}
